@if (loading() && !small()) {
<div class="loader">
  <div class="spinner spinner-bubble spinner-bubble-primary mr-3"></div>
</div>
}

@if (loading() && small()) {
<div class="loader-sm-container">
  <div class="spinner spinner-bubble spinner-bubble-primary"></div>
</div>
}